import { CONTACT_INFO } from "./data";

const SUBJECTS = {
  de: "Offerten-Anfrage – SHK Haustechnik",
  en: "Quote request – SHK Haustechnik",
  fr: "Demande de devis – SHK Haustechnik",
};

const BODIES = {
  de: `Guten Tag

Ich interessiere mich für eine unverbindliche Offerte und bitte um Kontaktaufnahme.

Dienstleistung: 
Adresse / Objekt: 
Beschreibung des Anliegens: 

Beste Grüsse
`,
  en: `Hello

I would like to request a non-binding quote and would appreciate being contacted.

Service: 
Address / property: 
Description of request: 

Best regards
`,
  fr: `Bonjour

Je souhaite recevoir un devis sans engagement et vous prie de me contacter.

Service: 
Adresse / objet: 
Description de la demande: 

Cordialement
`,
};

export const buildQuoteMailto = (lang = "de") => {
  const subject = encodeURIComponent(SUBJECTS[lang] || SUBJECTS.de);
  const body = encodeURIComponent(BODIES[lang] || BODIES.de);
  return `mailto:${CONTACT_INFO.email}?subject=${subject}&body=${body}`;
};
